import { List } from 'immutable';
import map from 'transmute/map';
import { buildThreadUpdate } from './buildThreadUpdate';
export const buildThreadUpdates = updates => {
  return List(map(buildThreadUpdate, updates));
};